import React from 'react';

import './css/styles.css';


class Card extends React.Component{
    render(){

        const backgroundColor = "#1FB2DE";

        const styles = {
            color_overlay: {
                backgroundColor: backgroundColor,
            }
        }

        return(
            <div className="card transparent z-depth-0">
                <a href={this.props.url} target="_blank" rel="noopener noreferrer">
                <div className="card-image">
                    <div className="custom-effect">
                        <img className="custom-shadowcard custom-border-img" src={this.props.index} />
                        <div 
                            className="card_overlay" 
                            style={styles.color_overlay}
                            >
                            <div className="card_text">
                                <i className="material-icons custom-fontSize">add_circle</i>
                                <h4 className="title_overlay">Ir al sitio</h4>
                            </div>
                        </div>
                    </div>
                </div>
                </a>
                <div className="card-content">
                    <p className={`custom-fontTitle`}>{this.props.titulo}</p>
                    <p className={`custom_fontText_especiales`}>{this.props.frase}</p>
                </div>
            </div>
            
        );
    }
}

export default Card;